import React from "react";
import { Box, Chip, Typography, Link } from "@mui/material";
import { getItemMetadata, getItemUrl } from "../../common/util";
import { IMG_PLACEHOLDER, STORAGE_BUCKET } from "../../common/constants";
import currency from "currency.js";
import ScheduleIcon from "@mui/icons-material/Schedule";
import RestaurantOutlinedIcon from "@mui/icons-material/RestaurantOutlined";
import InfoIcon from "@mui/icons-material/Info";
import EventOutlinedIcon from "@mui/icons-material/EventOutlined";
import moment from "moment";
import ErrorIcon from "@mui/icons-material/Error";
import AddIcon from "@mui/icons-material/Add";
import { Link as RouterLink } from "react-router-dom";
import BlockIcon from "@mui/icons-material/Block";

export default function ProductSummary(props) {
  const { product, query, date, isAvailable } = props;

  const metadata = getItemMetadata(product);

  return (
    <Box>
      <Link component={RouterLink} to={isAvailable ? getItemUrl(product) : ""} underline="none" sx={{ color: "inherit" }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "stretch",
            backgroundColor: isAvailable ? "#FEFEFE" : "#fff5f5",
            border: isAvailable ? "1px solid #EEE" : "1px solid #ffcdd2",
            borderRadius: "6px"
          }}
        >
          <Box p={1} textAlign={"left"} sx={{ display: "flex", flexDirection: "column", flex: 1, justifyContent: "space-between", minHeight: 0 }}>
            <Box sx={{ flex: "1 1 auto", minHeight: 0 }}>
              {query && <Chip label={product.type} size="small" />}
              <Typography variant="h6">{product.title}</Typography>
              <Box my={0.5}>
                {/*!isAvailable && (
                  <Typography color="error" sx={{ display: "flex", alignItems: "center", fontSize: ".9em" }}>
                    <ErrorIcon color="error" style={{ fontSize: "1.1em", marginRight: "3px" }} />
                    {`Unavailable for ${moment(date).format("ddd, MMM D, YYYY")}`}
                  </Typography>
                )}*/}
                {metadata.leadTime > 0 && (
                  <Box my={0.5}>
                    <Typography style={{ display: "flex", alignItems: "center", fontSize: ".9em", color: "#555" }}>
                      <ScheduleIcon style={{ fontSize: "1.1em", color: "#555", marginRight: "3px" }} />
                      Pre-order (min {metadata.leadTime} hour notice)
                    </Typography>
                  </Box>
                )}
                {metadata.dateRange && (
                  <Box my={0.5}>
                    <Typography style={{ display: "flex", alignItems: "center", fontSize: ".9em", color: "#555" }}>
                      <InfoIcon style={{ fontSize: "1.1em", color: "#555", marginRight: "3px" }} />
                      {metadata.dateRange}
                    </Typography>
                  </Box>
                )}
                {metadata.daysOfWeek && (
                  <Box my={0.5}>
                    <Typography style={{ display: "flex", alignItems: "center", fontSize: ".9em", color: "#555" }}>
                      <EventOutlinedIcon style={{ fontSize: "1.1em", color: "#555", marginRight: "3px" }} />
                      {metadata.daysOfWeek}
                    </Typography>
                  </Box>
                )}
                {/* metadata.size?.length > 0 && (
                  <Box my={0.5}>
                    <Typography style={{ display: "flex", alignItems: "center", fontSize: ".85em", color: "#555" }}>
                      <OpenInFullOutlinedIcon style={{ fontSize: "1em", color: "#555", marginRight: "3px" }} />
                      {metadata.size.length === 1 ? `${metadata.size[0]}` : "Multiple sizes"}
                    </Typography>
                  </Box>
                )*/}
                {metadata.dietary?.length > 0 && (
                  <Box my={0.5}>
                    <Typography style={{ display: "flex", alignItems: "center", fontSize: ".9em", color: "#555" }}>
                      <RestaurantOutlinedIcon style={{ fontSize: "1.1em", color: "#555", marginRight: "3px" }} />
                      {metadata.dietary.join(", ")} options
                    </Typography>
                  </Box>
                )}
                <Typography
                  variant="caption"
                  color="textSecondary"
                  style={{
                    color: "#777",
                    overflow: "hidden",
                    display: "-webkit-box",
                    "-webkit-line-clamp": isAvailable ? "2" : "1",
                    "line-clamp": isAvailable ? "2" : "1",
                    "-webkit-box-orient": "vertical"
                  }}
                  dangerouslySetInnerHTML={{
                    __html: product.description
                  }}
                />
              </Box>
            </Box>
            <Box>
              <Typography variant="body2" sx={{ fontWeight: "600" }} display="block">
                {currency(metadata.price.min).format()}
              </Typography>
            </Box>
          </Box>
          <Box sx={{ minWidth: "150px", maxWidth: "150px", minHeight: "150px", display: "flex", alignItems: "stretch", position: "relative" }}>
            <img
              src={product.images[0] || `${STORAGE_BUCKET}${IMG_PLACEHOLDER}`}
              alt={product.title}
              loading="lazy"
              style={{
                width: "100%",
                height: "100%",
                minHeight: "150px",
                aspectRatio: "1",
                objectFit: "cover",
                borderTopRightRadius: "6px",
                borderBottomRightRadius: "6px",
                filter: !isAvailable ? "grayscale(100%)" : "none"
              }}
            />
            <Box
              sx={{
                position: "absolute",
                bottom: "4px",
                right: "4px",
                backgroundColor: "#DDD",
                borderRadius: "50%",
                width: "32px",
                height: "32px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#333"
              }}
            >
              {isAvailable ? <AddIcon sx={{ fontSize: "20px" }} /> : <BlockIcon sx={{ fontSize: "20px", color: "#c0392b" }} />}
            </Box>
          </Box>
        </Box>
      </Link>
    </Box>
  );
}
